import { LitElement, html, css } from 'lit-element';

class SiteSearch extends LitElement {
    render() {
        return html` <div>SiteSearch</div> `;
    }
}

customElements.define('site-search', SiteSearch);
